import { BarceloComponent } from "components-utils";

const AllInvitation = {
  bwdTimeline: BarceloComponent({
    selector: ".bwd-timeline, .bwd-timeline-dl-id",
    path: "bwd/invitation/bwd-timeline/js/bwd-timeline",
  }),

  bwdInvitationHeader: BarceloComponent({
    selector: ".bwd-invitation-header, .bwd-invitation-header-dl-id",
    path: "bwd/invitation/bwd-invitation-header/js/bwd-invitation-header",
  }),

  bwdDiscountBanner: BarceloComponent({
    selector: ".bwd-discount-banner, .bwd-discount-banner-dl-id",
    path: "bwd/invitation/bwd-discount-banner/js/bwd-discount-banner",
  }),

  bwdDressCode: BarceloComponent({
    selector: ".bwd-dress-code, .bwd-dress-code-dl-id",
    path: "bwd/invitation/bwd-dress-code/js/bwd-dress-code",
  }),

  bwdHotelInfo: BarceloComponent({
    selector: ".bwd-hotel-info, .bwd-hotel-info-dl-id",
    path: "bwd/invitation/bwd-hotel-info/js/bwd-hotel-info",
  }),

  bwdInvitationHeaderDescription: BarceloComponent({
    selector: ".bwd-invitation-header-description, .bwd-invitation-header-description-dl-id",
    path: "bwd/invitation/bwd-invitation-header-description/js/bwd-invitation-header-description",
  }),

  bwdInvitationHeaderImages: BarceloComponent({
    selector: ".bwd-invitation-header-images, .bwd-invitation-header-images-dl-id",
    path: "bwd/invitation/bwd-invitation-header-images/js/bwd-invitation-header-images",
  }),

  bwdInvitationHeaderParagraph: BarceloComponent({
    selector: ".bwd-invitation-header-paragraph, .bwd-invitation-header-paragraph-dl-id",
    path: "bwd/invitation/bwd-invitation-header-paragraph/js/bwd-invitation-header-paragraph",
  }),

  bwdLocation: BarceloComponent({
    selector: ".bwd-location, .bwd-location-dl-id",
    path: "bwd/invitation/bwd-location/js/bwd-location",
  }),

  bwdWeddingGuest: BarceloComponent({
    selector: ".bwd-wedding-guest, .bwd-wedding-guest-dl-id",
    path: "bwd/invitation/bwd-wedding-guest/js/bwd-wedding-guest",
  }),

  bwdWeddingGuestCoupon: BarceloComponent({
    selector: ".bwd-wedding-guest-coupon, .bwd-wedding-guest-coupon-dl-id",
    path: "bwd/invitation/bwd-wedding-guest-coupon/js/bwd-wedding-guest-coupon",
  }),

  bwdWeddingGifts: BarceloComponent({
    selector: ".bwd-wedding-gifts, .bwd-wedding-gifts-dl-id",
    path: "bwd/invitation/bwd-wedding-gifts/js/bwd-wedding-gifts",
  }),
};

export default AllInvitation;
